import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select", "form", "reason"];

  submit() {
    if (this._isFinalStatus(this.selectTarget.value)) {
      let message = prompt("Proszę podać powód zamknięcia zgłoszenia:");

      if (message !== null || message !== "") {
        this.reasonTarget.value = message;
        this.formTarget.submit();
      }
    } else {
      this.formTarget.submit();
    }
  }

  _isFinalStatus(status) {
    const finalStatuses = ["closed", "rejected"];

    return finalStatuses.indexOf(status) !== -1;
  }
}
